import React from 'react'
import { Grid, Box, Typography } from '@mui/material'
import useStyles from './Styles'
import Image from 'next/image'
import Download from 'src/assets/images/press/download.svg'

interface image {
  data: {
    attributes: {
      name: string
      width: number
      height: number
      url: string
    }
  }[]
}

interface Props {
  details: { imageDescription: string; type: string; image: image }[]
}
function AccordianDetail({ details }: Props) {
  const { classes } = useStyles()

  return (
    <div>
      <Grid
        container
        columnSpacing={{ lg: 6, md: 6, sm: 6, xs: 0 }}
        justifyContent="center"
      >
        {details?.map((detail, idx) => {
          return (
            <Grid item lg={4} md={4} sm={6} xs={12} key={idx}>
              <Box>
                <Box className={classes.imgWrapper}>
                  <Image
                    src={`${detail.image.data[0].attributes.url}`}
                    alt="image"
                    className={`${idx !== 2 ? classes.logos : classes.image}`}
                    width={detail.image.data[0].attributes.width}
                    height={detail.image.data[0].attributes.height}
                  />
                </Box>
                <Box className={classes.descWrapper}>
                  <Typography className={classes.title}>
                    {detail.imageDescription}
                  </Typography>
                  <a
                    href={`${
                      detail.image.data[0].attributes.url
                        ? detail.image.data[0].attributes.url
                        : '#'
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Image src={Download} alt="image" className="download" />
                  </a>
                </Box>
                <Typography className={classes.type}>{detail.type}</Typography>
              </Box>
            </Grid>
          )
        })}
      </Grid>
    </div>
  )
}

export default AccordianDetail
